import React from 'react';
import { B } from '../constants';

export default function PrivacyScreen({ goScreen }) {
  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '40px 20px', fontFamily: "'Montserrat',sans-serif", lineHeight: 1.7 }}>
      <button onClick={() => goScreen(-1)} style={{ background: 'none', border: 'none', fontSize: 24, cursor: 'pointer', marginBottom: 20 }}>← Back</button>
      
      <h1 style={{ fontFamily: "'Playfair Display',serif", fontSize: 32, color: B.night, marginBottom: 24 }}>Privacy Policy</h1>
      
      <p style={{ color: B.muted, marginBottom: 32 }}>Last updated: April 2026</p>

      <div style={{ fontSize: 14, color: '#444' }}>
        <h2 style={{ fontSize: 18, marginTop: 32, marginBottom: 12, color: B.night }}>1. Information We Collect</h2>
        <ul style={{ marginLeft: 20, marginTop: 8 }}>
          <li><strong>Account information:</strong> Name, email, password (encrypted)</li>
          <li><strong>Profile data:</strong> Avatar, travel preferences</li>
          <li><strong>Trip data:</strong> itineraries, day logs, experiences, photos</li>
          <li><strong>Usage data:</strong> How you use our app (for improvements)</li>
          <li><strong>Device data:</strong> Browser type, device info (for analytics)</li>
        </ul>

        <h2 style={{ fontSize: 18, marginTop: 32, marginBottom: 12, color: B.night }}>2. How We Use Your Information</h2>
        <ul style={{ marginLeft: 20, marginTop: 8 }}>
          <li>To provide and improve our services</li>
          <li>To generate personalized trip itineraries</li>
          <li>To communicate with you about your account</li>
          <li>To analyze usage and improve user experience</li>
          <li>To comply with legal obligations</li>
        </ul>

        <h2 style={{ fontSize: 18, marginTop: 32, marginBottom: 12, color: B.night }}>3. Data Sharing</h2>
        <p>We <strong>do not sell</strong> your personal data. We may share data with:</p>
        <ul style={{ marginLeft: 20, marginTop: 8 }}>
          <li><strong>Service providers:</strong> Companies that help us operate (hosting, AI services)</li>
          <li><strong>AI providers:</strong> Google Gemini, Anthropic (for generating itineraries)</li>
          <li><strong>Legal requirements:</strong> When required by law</li>
        </ul>

        <h2 style={{ fontSize: 18, marginTop: 32, marginBottom: 12, color: B.night }}>4. Data Security</h2>
        <p>We implement industry-standard security measures including encryption, access controls, and regular security audits. However, no system is 100% secure - we cannot guarantee absolute security.</p>

        <h2 style={{ fontSize: 18, marginTop: 32, marginBottom: 12, color: B.night }}>5. Your Rights (GDPR/CCPA)</h2>
        <p>Depending on your location, you may have rights to:</p>
        <ul style={{ marginLeft: 20, marginTop: 8 }}>
          <li><strong>Access:</strong> Request a copy of your data</li>
          <li><strong>Correction:</strong> Request corrections to inaccurate data</li>
          <li><strong>Deletion:</strong> Request deletion of your data ("right to be forgotten")</li>
          <li><strong>Portability:</strong> Request your data in a portable format</li>
          <li><strong>Opt-out:</strong> Object to certain processing</li>
        </ul>

        <h2 style={{ fontSize: 18, marginTop: 32, marginBottom: 12, color: B.night }}>6. Cookies & Tracking</h2>
        <p>We use cookies to:</p>
        <ul style={{ marginLeft: 20, marginTop: 8 }}>
          <li>Keep you logged in</li>
          <li>Remember your preferences</li>
          <li>Understand how you use our app</li>
        </ul>
        <p>You can manage cookies through your browser settings.</p>

        <h2 style={{ fontSize: 18, marginTop: 32, marginBottom: 12, color: B.night }}>7. Data Retention</h2>
        <p>We retain your data as long as your account is active, or as needed to provide services. You can request deletion at any time.</p>

        <h2 style={{ fontSize: 18, marginTop: 32, marginBottom: 12, color: B.night }}>8. Children's Privacy</h2>
        <p>Our service is not intended for children under 13. We do not knowingly collect data from children.</p>

        <h2 style={{ fontSize: 18, marginTop: 32, marginBottom: 12, color: B.night }}>9. Changes to Policy</h2>
        <p>We may update this policy periodically. We will notify you of material changes.</p>

        <h2 style={{ fontSize: 18, marginTop: 32, marginBottom: 12, color: B.night }}>10. Contact</h2>
        <p>For privacy concerns or to exercise your rights, contact us at privacy@greatbreak.com</p>
      </div>
    </div>
  );
}